import Ticker from "../components/landing/Ticker";
import ReplayNav from "../components/replay/ReplayNav";
import ReplayHero from "../components/replay/ReplayHero";
import Recap from "../components/replay/Recap";
import MethodStrip from "../components/replay/MethodStrip";
import Manifest from "../components/replay/Manifest";
import Guarantee from "../components/replay/Guarantee";
import ReplayHost from "../components/replay/ReplayHost";
import Objections from "../components/replay/Objections";
import ProofPlaceholders from "../components/replay/ProofPlaceholders";
import ReplayFAQ from "../components/replay/ReplayFAQ";
import ApplySection from "../components/replay/ApplySection";
import ReplayFooter from "../components/replay/ReplayFooter";
import ReplayStickyCTA from "../components/replay/ReplayStickyCTA";
import { SHOW_GUARANTEE } from "../components/replay/config";

const TICKER_ITEMS = [
  "VA BETTER-BUY MASTERCLASS™",
  "THE BETTER DEAL METHOD™",
  "CLARIFY · STRUCTURE · GUIDE",
  "FLORIDA & PENNSYLVANIA",
  "FREE BETTER DEAL REVIEW™",
  "EDUCATION, NOT A COMMITMENT TO LEND",
];

export default function ReplayPage() {
  return (
    <>
      <ReplayNav />
      <main>
        <ReplayHero />
        <Ticker items={TICKER_ITEMS} />
        <Recap />
        <MethodStrip />
        <Manifest />
        {SHOW_GUARANTEE && <Guarantee />}
        <ReplayHost />
        <Objections />
        <ProofPlaceholders />
        <ReplayFAQ />
        <ApplySection />
      </main>
      <ReplayFooter />
      <ReplayStickyCTA />
    </>
  );
}
